import {
  API_URL,
  CHECKOUT_PAYMENT_URL,
  CODEPUSH_DEPLOYMENT_KEY,
  FACEBOOK_APP_ID,
  GOOGLE_MAPS_API_KEY,
  NODE_ENV,
  REMOTE_CONFIG_FETCH_INTERVAL,
  SENTRY_DSN,
  WEB_CLIENT_ID_ANDROID,
  WEB_CLIENT_ID_IOS,
} from '@env';

export default {
  API_URL,
  CHECKOUT_PAYMENT_URL,
  CODEPUSH_DEPLOYMENT_KEY,
  FACEBOOK_APP_ID,
  GOOGLE_MAPS_API_KEY,
  NODE_ENV,
  REMOTE_CONFIG_FETCH_INTERVAL,
  SENTRY_DSN,
  WEB_CLIENT_ID_ANDROID,
  WEB_CLIENT_ID_IOS,
};
